/** Úroveň, která má svítit na zvonku / v režimu „jen důležité“. */
export const IMPORTANT_NOTIF_LEVELS = new Set([
  'warn',
  'warning',
  'error',
  'action',
  'critical',
]);

/** Režim zvonku (ne seznamový filtr). Chybějící klíč = zapnuto. */
export const IMPORTANT_ONLY_KEY = 'acm_notif_important_only';
export const IMPORTANT_ONLY_EVENT = 'acm-notif-important-only-change';

export function isImportantNotification(n: {
  level?: string | null;
  requires_ack?: boolean;
}): boolean {
  return n.requires_ack === true || IMPORTANT_NOTIF_LEVELS.has(String(n.level ?? ''));
}

export function readImportantOnly(): boolean {
  try {
    const v = localStorage.getItem(IMPORTANT_ONLY_KEY);
    if (v === '0') return false;
    if (v === '1') return true;
  } catch { /* private mode */ }
  return true;
}

export function writeImportantOnly(on: boolean): void {
  try {
    localStorage.setItem(IMPORTANT_ONLY_KEY, on ? '1' : '0');
  } catch { /* private mode */ }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(IMPORTANT_ONLY_EVENT));
  }
}

/** Odznak u zvonku — režim, ne aktivní záložka filtru. Urgent vždy přebije. */
export function notificationBadge(opts: {
  importantOnly: boolean;
  urgentCount: number;
  unreadImportant: number;
  unreadAll: number;
}): { urgent: boolean; count: number } {
  if (opts.urgentCount > 0) {
    return { urgent: true, count: opts.urgentCount };
  }
  const count = opts.importantOnly ? opts.unreadImportant : opts.unreadAll;
  return { urgent: false, count };
}
